<template>
  <header class="gv-editor-bar" :data-video-id="videoId">
    <gs-button
      class="gv-editor-bar__back"
      variant="ghost"
      size="sm"
      @click="$emit('back')"
    >
      <gs-icon name="arrow-left" size="16" />
      <span>Videos</span>
    </gs-button>

    <div class="gv-editor-bar__identity">
      <span class="gv-editor-bar__eyebrow">GrooveVideo · Editor</span>
      <h1 class="gv-editor-bar__title" :title="title">{{ title }}</h1>
    </div>

    <div class="gv-editor-bar__actions">
      <gs-button
        data-action="analytics"
        variant="outline"
        size="sm"
        @click="$emit('analytics')"
      >
        <gs-icon name="chart" size="16" />
        <span>Analytics</span>
      </gs-button>
      <gs-button
        data-action="share"
        variant="outline"
        size="sm"
        @click="$emit('share')"
      >
        <gs-icon name="share" size="16" />
        <span>Share</span>
      </gs-button>
      <gs-button
        data-action="save"
        size="sm"
        :variant="isDirty ? 'primary' : 'outline'"
        :disabled="!isDirty || saving"
        :class="{ 'is-dirty': isDirty && !saving, 'is-clean': !isDirty && !saving }"
        @click="$emit('save')"
      >{{ saving ? 'Saving…' : isDirty ? 'Save changes' : 'All changes saved' }}</gs-button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'EditorTopBar',

  props: {
    title: {
      type: String,
      default: '',
    },
    isDirty: Boolean,
    saving: Boolean,
    videoId: {
      type: [String, Number],
      default: '',
    },
  },
};
</script>

<style scoped>
.gv-editor-bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 64px;
  padding: 10px 24px;
  background: var(--gs-surface);
  border-bottom: 1px solid var(--gs-border);
}

.gv-editor-bar__back {
  flex: 0 0 auto;
  gap: 8px;
}

.gv-editor-bar__identity {
  flex: 1 1 auto;
  min-width: 0;
}

.gv-editor-bar__eyebrow {
  display: block;
  color: var(--gs-muted-foreground);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1.3;
  text-transform: uppercase;
}

.gv-editor-bar__title {
  margin: 0;
  overflow: hidden;
  color: var(--gs-foreground);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gv-editor-bar__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.gv-editor-bar__actions ::v-deep .gs-button {
  gap: 8px;
}

.gv-editor-bar__actions ::v-deep .gs-button.is-dirty {
  animation: gs-save-attention 2.4s ease-in-out infinite;
}

.gv-editor-bar__actions ::v-deep .gs-button.is-clean {
  color: var(--gs-muted-foreground);
}

/* Soft pink halo that breathes while there is something to save. */
@keyframes gs-save-attention {
  0%,
  100% {
    box-shadow: 0 0 0 0 var(--gs-primary-soft);
  }

  50% {
    box-shadow: 0 0 0 6px var(--gs-primary-soft);
  }
}

@media (max-width: 767px) {
  .gv-editor-bar {
    flex-wrap: wrap;
    padding: 10px 16px;
  }

  .gv-editor-bar__identity {
    order: 3;
    flex: 1 1 100%;
  }

  .gv-editor-bar__actions {
    flex: 1 1 auto;
    justify-content: flex-end;
  }
}
</style>
